import { faArrowRight, faBullseyeArrow } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { Button } from '../../shared/components/button/Button';
import { InfoSlider } from '../../shared/components/slider/infoSlider/InfoSlider';

function ReviewGoals(props) {
  const { t } = useTranslation();
  const goals = useSelector((state) => state.goals.goals);

  return (
    <div className="popup-overlay">
      <div className="popup-container results goals ">
        <div className="popup-title fs-mask">{t('G024')}</div>
        <div className="goalsrw fs-mask">
          <InfoSlider title="" id="review-goals-slider" textArr={goals} />
          <div className="orange-box">
            <div className="ob-title">
              <FontAwesomeIcon icon={faBullseyeArrow} /> {t('G086')}
            </div>
            <div className="ob-text">{t('G087')}</div>
            <Button onClick={props.editGoals} className="nb" color="dark">
              {t('G031')}
            </Button>
          </div>
          <Button
            onClick={props.handleClose}
            className="full_width"
            color="dark"
            icon={{ faIconDefinition: faArrowRight, size: 'lg' }}
          >
            {t('G032')}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ReviewGoals;
